import { useShareShipmentForm } from '../share/mutations'
import ShareForm from '../share/ShareForm'
import { SharePanelMain } from '../share/SharePanelMain'
import {
  SliderContentBody,
  SliderContentFooter,
  SliderContentHeader,
} from './SliderContentLayout'
import type { ShipmentContentProps } from './types'

export const DetailsSharePanel = ({
  load,
  setActiveSlider,
}: ShipmentContentProps) => {
  const { shares = [], documents = [], loadId } = load
  const shareForm = useShareShipmentForm({
    loadId,
    documents,
  })

  return (
    <>
      <SliderContentBody>
        <SliderContentHeader {...load} prefix="Documents for" noBorder />
        <SharePanelMain
          workflow={load.workflow}
          className="flex-1"
          form={shareForm}
          shares={shares}
        />
      </SliderContentBody>
      <SliderContentFooter>
        <ShareForm
          form={shareForm}
          shareShipment={emails => {
            shareForm.submitShare(emails, {
              onSuccess: () => setActiveSlider(undefined),
            })
          }}
        />
      </SliderContentFooter>
    </>
  )
}
